import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';
import { Row, Col, Image, Button } from 'react-bootstrap';
import { UserIcon, HomeIcon } from '@heroicons/react/24/solid';
import '../styles/roomCard.css'
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const RoomPreview = ({ gemImage, title, description, capacity, bed, images, price, facilities, color, mode }) => {
  const { t } = useTranslation()

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const CarouselImages = () => {
    return (
      <Carousel className="roomPreviewCarouselContainer" activeIndex={index} onSelect={handleSelect} controls={true} indicators={true} style={{borderRadius: '14px', overflow: 'hidden'}}>
        {images?.map((image, index) => 
          <Carousel.Item key={index}>
            <Image src={image.src} style={{height: '25rem', width: '100%', objectFit: 'cover'}} alt="RoomCardHorizontalCarouselImage"/>
          </Carousel.Item>
        )}
      </Carousel>
    )
  }

  return (
    <>
        <Card 
          className="md p-0 roomPreviewContainer" 
          style={{ "--color": `${color}`, cursor: 'pointer', borderRadius: '14px'}}
        >
              <CarouselImages/>
        </Card>
        <Card className="bg-white shadow-sm mt-4 d-flex">
              <Card.Body className="ContainerBody">

                <Card.Title className="d-flex flex-row">
                  <Image className="roomGemImage" src={gemImage}/>
                  {mode === "single" ? <h4 style={{fontWeight: 'bold'}}>{title}</h4> : title}
                </Card.Title>

                <Row>
                  <Col className="col-auto">
                    <UserIcon style={{height: '1rem', color: '#595959', marginTop: '-0.1rem', marginRight: '0.25rem'}} alt="RoomCardHorizontalDetailsCardUserIcon"/>
                  </Col>
                  <Col className="col-auto" style={{marginRight: '.5rem'}}>
                    <Card.Text style={{color: '#595959', fontWeight: '400'}}>{capacity} Guests</Card.Text>
                  </Col>

                  <Col className="col-auto">
                    <HomeIcon style={{height: '1rem', color: '#595959', marginTop: '-0.2rem', marginRight: '0.25rem'}} alt="RoomCardHorizontalDetailsCardHomeIcon"/>
                  </Col>
                  <Col className="col-auto" style={{marginRight: '.5rem'}}>
                    <Card.Text style={{color: '#595959', fontWeight: '400',}}>{bed}</Card.Text>
                  </Col>
                </Row>

                <hr style={{width: '100%'}} />

                <Card.Text className="cardContainerDescription">{description}</Card.Text>

                {mode !== "single" && 
                  <Row className="d-flex justify-content-between" style={{marginTop: '1rem', marginBottom: '-1rem'}}>
                    <Col className="col-auto">
                      <Button className="bookNowButton" style={{padding: '.35rem 2rem', "--color": `${color}`}}>{t('BOOKNOW')}</Button>
                    </Col>

                    <Col className="col-auto mt-3">
                      <Card.Text variant="primary" style={{float: 'right', fontWeight: '400'}}>{price}</Card.Text>
                    </Col>
                  </Row>
                }
              </Card.Body>
           
        </Card>
    </>
  )
}

export default RoomPreview